export type Opacities = {
  default: number;
  low: number;
  minimum: number;
  disabled: number;
  uiFuseControlTop: number;
  uiFuseControlInnerSide: number;
  uiFuseControlOuterSide: number;
  uiFuseControlInnerBottom: number;
  uiFuseControlOuterBottom: number;
};

export const opacities = {
  default: 1,
  low: 0.8,
  minimum: 0.7,
  disabled: 0.6,
};

export const opacityTokens = {
  default: 'var(--opacities-default)',
  disabled: 'var(--opacities-disabled)',
  low: 'var(--opacities-low)',
  minimum: 'var(--opacities-minimum)',
  uiFuseControlTop: 'var(--opacities-ui-fuse-control-top)',
  uiFuseControlInnerSide: 'var(--opacities-ui-fuse-control-inner-side)',
  uiFuseControlOuterSide: 'var(--opacities-ui-fuse-control-outer-side)',
  uiFuseControlInnerBottom: 'var(--opacities-ui-fuse-control-inner-bottom)',
  uiFuseControlOuterBottom: 'var(--opacities-ui-fuse-control-outer-bottom)',
} as const;
